import React from 'react';
import { useProjectLinkService } from "nekst-api";
import { usePopupManager } from 'ui-builder';
import { ConfirmDeletePopup } from 'features/nekst-widgets';

export default function useUnlinkProjectAction(
  projectId: number,
  linkId: number,
) {
  const projectLinkService = useProjectLinkService();

  const popupManager = usePopupManager();

  return {
    label: 'Unlink',
    onSelected: async () => {
      popupManager.openPopup(
        <ConfirmDeletePopup
          deleteFunc={() => {
            return projectLinkService.removeLink(projectId, linkId);
          }}
          message="Are you sure you want to unlink this transaction from Follow Up Boss Deal? After that, Nekst updates will not be synced with FUB Deal."
        />
      )

    },
    value: 'unlink'
  }
}
